import { DbMongoBaseInfos } from "./db-mongo-base-infos";

import { DbMetadataViewGroupColumn } from "./db-metadata-view-group-column";

export class DbMetadataViewGroupRow extends DbMongoBaseInfos {
  columns: DbMetadataViewGroupColumn[] | null = null;

  constructor(init?: Partial<DbMetadataViewGroupRow>) {
    super();
    Object.assign(this, init);
  }
}
